import React, { useState} from 'react';

import { Modal, useModal } from "src/components/Modal/Modal";
import Refund from "src/components/Refund/Refund";
import ContextMenu from "src/components/ContextMenu/ContextMenu";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./CourseTransactions.module.scss";

interface CustomTransactionCellRendererProps extends CustomCellRendererProps {
  onRefund(): void
}

enum ModalType {
  REFUND = 'refund'
}

export const ActionsRenderer = (props: CustomTransactionCellRendererProps) => {
  const { isShown, toggle } = useModal();
  const [modalType, setModalType] = useState<ModalType>(ModalType.REFUND);

  const menuOptions = [{
    label: "Refund Transaction",
    onClick: () => {
      setModalType(ModalType.REFUND);
      toggle();
    }
  }];

  return (<div className={styles.ActionRenderer}>
    <ContextMenu
      options={menuOptions}
    />
    <Modal
      className={modalType === ModalType.REFUND ? "refundModal" : ""}
      isShown={isShown}
      hide={() => { toggle(); }}
      modalContent={
        modalType === ModalType.REFUND ? (
          <Refund
            type="course"
            transaction={props.value.transaction}
            onRefund={() => {
              props.onRefund();
              toggle();
            }}
            onCancel={() => {
              toggle();
            }}
          />
        ): <></>
      }
    />
  </div>);
};
